export default "/images/435a632a1387cd6c486b06d40ccc8f6b.avif";